export default {
  participants: [],
  pagination: {},
  participant: {}
}
